export default __webpack_public_path__ + "static/media/face1.9dd80440.png";